import type { ReactNode } from 'react'

import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'

import type { REWARD_CITATION_TYPE } from '../../../models/rewardCitationType.enum'
import { useRewardCitationsQuery } from '../../../services/useRewardCitationsQuery'
import { PrayRewardCitationBase } from '../PrayRewardCitationBase/PrayRewardCitationBase'

type TPrayRewardCitationProps = {
  rewardType?: REWARD_CITATION_TYPE
}

export const PrayRewardCitation = ({ rewardType }: TPrayRewardCitationProps): ReactNode => {
  const { data: citation, isPending } = useRewardCitationsQuery({ type: rewardType })

  if (isPending) {
    return (
      <Placeholder className="flex-col items-center gap-8 bg-transparent">
        <PlaceholderMedia radius="full" className="h-40 w-40" contrast="light" />
        <PlaceholderLine className="h-10" contrast="light" />
        <PlaceholderLine className="h-10" length="half" contrast="light" />
      </Placeholder>
    )
  }
  return <PrayRewardCitationBase content={citation?.content} image={citation?.image} author={citation?.author} />
}
